module.exports = __webpack_public_path__ + "media/images/logo/fedex-4d7d9b211c326e58af9523bcead1b939.gif";